import { render } from "./AppTextLoader.vue?vue&type=template&id=6a63e2f2"
import script from "./AppTextLoader.vue?vue&type=script&lang=js"
export * from "./AppTextLoader.vue?vue&type=script&lang=js"

import "./AppTextLoader.vue?vue&type=style&index=0&id=6a63e2f2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__